var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1194_2292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6953 25H11.7188C11.6654 24.9828 11.6108 24.97 11.5553 24.9616C10.0488 24.8509 8.60156 24.4967 7.24349 23.834C3.38238 21.9507 1.03299 18.8987 0.195312 14.6777C0.104167 14.2174 0.0651042 13.7467 0 13.2812V11.7188C0.0195312 11.5586 0.0416669 11.3991 0.059245 11.2389C0.353516 8.53711 1.38802 6.16081 3.21224 4.14258C5.14193 2.00977 7.52929 0.68099 10.3704 0.188802C10.8177 0.111328 11.2695 0.0585937 11.7188 0H13.2812C13.3429 0.0177163 13.4058 0.0309882 13.4694 0.0397136C15.4069 0.186198 17.2194 0.740885 18.877 1.75456C22.1204 3.73828 24.1068 6.60287 24.8086 10.3483C24.8932 10.804 24.9388 11.2637 25 11.7214V13.235C24.9466 13.6608 24.9154 14.0905 24.8372 14.5117C24.0286 18.8563 21.6306 21.982 17.6432 23.8887C17.1133 24.1419 16.5469 24.3197 15.974 24.5397V15.2656H18.6497C18.7852 14.2142 18.918 13.1875 19.0547 12.1276H15.9733C15.966 12.0867 15.9608 12.0454 15.9577 12.0039C15.9577 11.304 15.9479 10.6035 15.9661 9.9043C15.9863 9.09635 16.3997 8.67773 17.2109 8.64258C17.7637 8.61849 18.3177 8.63021 18.8704 8.6263H19.1243V5.77474C18.1432 5.75977 17.1758 5.69922 16.2135 5.74935C15.7033 5.78637 15.2048 5.9205 14.7448 6.14453C13.431 6.76693 12.8535 7.90885 12.7533 9.30078C12.6927 10.1432 12.7279 10.9935 12.7201 11.8398C12.7201 11.9342 12.7201 12.0286 12.7201 12.1504H10.0508V15.2689H12.7201V15.5599C12.7201 18.6194 12.7201 21.6793 12.7201 24.7396C12.7188 24.8236 12.7038 24.9121 12.6953 25Z",
    fill: "#2E296C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1194_2292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d18873a74f030f167759de84bcf5d142.svg";
export { ForwardRef as ReactComponent };